<template>
    <div>
        <v-snackbar :center="true" :timeout="3000" :top="true" color="error" v-model="snackbar">
            {{ notificationMessage }}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <div class="login-container">
            <v-card class="login-card">
                <v-card-text class="px-4 py-1">
                    <top-header-section text-item="Generate/Check voucher"/>
                    <v-form ref="formRef">
                        <v-layout column wrap>
                            <v-flex xs12>
                                <v-alert
                                    @input="clearVoucher"
                                    dismissible
                                    outlined
                                    type="success"
                                    v-if="voucher_number">
                                    Voucher Number: <b id="copy_content"> {{voucher_number}} </b><span
                                    class="ml-2"></span>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <a href="#" style="color: snow">
                                                <v-icon
                                                    @click="copyToClipboard"
                                                    color="grey darken-4"
                                                    dark
                                                    v-on="on"
                                                >mdi-content-copy
                                                </v-icon>
                                            </a>
                                        </template>
                                        <span>Copy to clipboard</span>
                                    </v-tooltip>
                                </v-alert>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    :rules="[rules.required]"
                                    class="mt-2"
                                    label="Submission number"
                                    outlined
                                    prepend-inner-icon="mdi-alpha-s-box"
                                    type="text"
                                    v-model="form.submission_no"
                                />
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                    :rules="[rules.required]"
                                    class="mt-2"
                                    label="Passport number"
                                    outlined
                                    prepend-inner-icon="mdi-passport"
                                    type="text"
                                    v-model="form.passport_number"
                                />
                            </v-flex>
                            <v-flex xs12 class="px-3">
                                <v-layout row wrap justify-center>
<!--                                    <v-flex xs6>-->
<!--                                        <v-btn :disabled="!!voucher_number"-->
<!--                                               :loading="loading"-->
<!--                                               @click="checkVoucher"-->
<!--                                               class="login-button"-->
<!--                                               color="primary"-->
<!--                                        >Check voucher-->
<!--                                        </v-btn>-->
<!--                                    </v-flex>-->
                                    <v-flex xs6 class="pl-2">
                                        <v-btn :disabled="!!voucher_number"
                                               :loading="loading"
                                               @click="generateVoucher"
                                               class="login-button"
                                               color="success"
                                        >Generate voucher
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-form>

                </v-card-text>
            </v-card>
        </div>
        <developed-by-item/>

    </div>
</template>

<script>
    import DevelopedByItem from "../components/DevelopedBy";
    import TopHeaderSection from "../components/TopHeaderSection";
    import {API_URL, VERSIONED_API_URL} from "../config/config";
    import axios from "axios"

    export default {
        components: {DevelopedByItem, TopHeaderSection},
        data: () => ({
            loading: false,
            snackbar: false,
            valid: true,
            notificationMessage: "",
            form: {
                passport_number: "",
            },
            selected: null,
            rules: {
                required: value => !!value || "Required.",
            },
            voucher_number: null
        }),
        methods: {
            copyToClipboard() {
                this.copyToClipboardFun(this.voucher_number);
            },
            clearVoucher() {
                this.$refs.formRef.reset();
                this.voucher_number = null;
            },
            copyToClipboardFun(text) {
                if (window.clipboardData && window.clipboardData.setData) {
                    // IE specific code path to prevent textarea being shown while dialog is visible.
                    return clipboardData.setData("Text", text);

                } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                    var textarea = document.createElement("textarea");
                    textarea.textContent = text;
                    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                        return document.execCommand("copy");  // Security exception may be thrown by some browsers.
                    } catch (ex) {
                        console.warn("Copy to clipboard failed.", ex);
                        return false;
                    } finally {
                        document.body.removeChild(textarea);
                    }
                }
            },
            // async checkVoucher() {
            //     if (!this.form.passport_number) {
            //         this.snackbar = true;
            //         this.notificationMessage = 'Passport number is required';
            //         return;
            //     }
            //     try {
            //         const response = await axios.get(`${VERSIONED_API_URL}/passport-status/${this.form.passport_number}`);
            //         this.voucher_number = response.data;
            //
            //     } catch (e) {
            //         if (e.response.status === 404) {
            //             this.snackbar = true;
            //             this.notificationMessage = 'Record not found';
            //         }
            //     }
            // },
            // async generateVoucher() {
            //     if (this.$refs.formRef.validate()) {
            //         this.voucher_number = false;
            //         try {
            //
            //             this.loading = true;
            //             const response = await axios.post(`${VERSIONED_API_URL}/generate-voucher`, {
            //                 passport_number: this.form.passport_number,
            //                 submission_no: this.form.submission_no,
            //                 dob: this.form.dob
            //             });
            //             this.loading = false;
            //             this.voucher_number = response.data.voucher_number;
            //
            //         } catch (e) {
            //             this.snackbar = true;
            //             this.notificationMessage = e.response.data.message;
            //             this.loading = false;
            //         }
            //     }
            // }
          async generateVoucher() {
            if (this.$refs.formRef.validate()) {
              this.voucher_number = false;
              try {

                this.loading = true;
                const response = await axios.post(`${VERSIONED_API_URL}/check-payment-generate-voucher`, {
                  passport_number: this.form.passport_number,
                  submission_no: this.form.submission_no,
                  dob: this.form.dob
                });
                this.loading = false;
                this.voucher_number = response.data.voucher_number;

              } catch (e) {
                this.snackbar = true;
                this.notificationMessage = e.response.data.message;
                this.loading = false;
              }
            }
          }
        }
    };
</script>
